import { Action, createHook, createStore } from 'react-sweet-state'

import { IRoleEnum } from '../types/router'

import { IUser } from './usersStore'

type IUserProfileState = {
    userProfile: IUser
}

const userProfileInitialState: IUserProfileState = {
    userProfile: { _id: '', username: '', email: '', role: IRoleEnum.USER },
}

const userProfileActions = {
    setMyProfile:
        (userProfile: IUser): Action<IUserProfileState> =>
        ({ setState }) => {
            setState({ userProfile })
        },
    editMyProfileName:
        (username: string): Action<IUserProfileState> =>
        ({ setState, getState }) => {
            const userProfile = getState().userProfile

            if (!userProfile) return

            setState({ userProfile: { ...userProfile, username } })
        },
    editMyProfileEmail:
        (email: string): Action<IUserProfileState> =>
        ({ setState, getState }) => {
            const userProfile = getState().userProfile

            if (!userProfile) return

            setState({ userProfile: { ...userProfile, email } })
        },
}

const Store = createStore({
    initialState: userProfileInitialState,
    actions: userProfileActions,
})

export const useUserProfileStore = createHook(Store)
